document.addEventListener('DOMContentLoaded', function () {
	const menuBtn = document.querySelector('.menu-button');
	const mainMenu = document.querySelector('.main-menu');
	menuBtn.addEventListener('click', (e) => {
		e.stopPropagation();
		mainMenu.classList.toggle('hidden');
	});
	document.querySelector('.modal-close').addEventListener('click', (e) => {
		e.stopPropagation();
		document.querySelector('.modal-menu').classList.add('modal-hidden');
		document.body.style.overflow = 'unset';
	});
	document.querySelector('.modal-open').addEventListener('click', (e) => {
		e.stopPropagation();
		document.querySelector('.modal-menu').classList.remove('modal-hidden');
		document.body.style.overflow = 'hidden';
	});

	document.querySelectorAll('.menu-open').forEach((element) => {
		element.addEventListener('click', (e) => {
			e.stopPropagation();
			document.querySelectorAll('.sub-menu').forEach((el) => el.classList.remove('translate-x-[120%]'));
		});
	});
	document.querySelectorAll('.menu-close').forEach((element) => {
		element.addEventListener('click', (e) => {
			e.stopPropagation();
			document.querySelectorAll('.sub-menu').forEach((el) => el.classList.add('translate-x-[120%]'));
		});
	});
	const menu = document.querySelector('.desktop-menu');
	document.addEventListener('click', function (event) {
		if (!menu.contains(event.target) && !menu.classList.contains('hidden')) {
			mainMenu.classList.toggle('hidden');
		}
	});
});
